import { memo, useMemo, type FC, type ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Media } from '../../../theme/Media.tsx';
import Typography from '../../Typography/index.ts';
import { ActionsWrapper, InnerWrapper, SubTitleWrapper, TabsWrapper, TitleWrapper, Wrapper } from './styled.ts';

export interface PageHeaderProps {
  title: string;
  subTitle?: ReactNode;
  actions?: ReactNode;
  tabs?: ReactNode;
}

export const PageHeader: FC<PageHeaderProps> = memo(function PageHeader({ title, subTitle, actions, tabs: tabsProp }) {
  const isDesktop = useMediaQuery({ query: Media.lgMin });

  const tabs = useMemo(
    () =>
      tabsProp ? (
        <TabsWrapper $isDesktop={isDesktop} data-testid='page-header-tabs'>
          {tabsProp}
        </TabsWrapper>
      ) : null,
    [tabsProp, isDesktop],
  );

  return (
    <Wrapper data-testid='page-header-wrapper'>
      <InnerWrapper data-testid='page-header-inner-wrapper'>
        <TitleWrapper>
          <Typography.Headline data-testid='page-header-title'>{title}</Typography.Headline>
          {subTitle ? <SubTitleWrapper data-testid='page-header-subtitle'>{subTitle}</SubTitleWrapper> : null}
        </TitleWrapper>
        {actions ? <ActionsWrapper data-testid='page-header-actions'>{actions}</ActionsWrapper> : null}
      </InnerWrapper>
      {tabs}
    </Wrapper>
  );
});
